import { render, staticRenderFns } from "./ExBreadcrumbs.vue?vue&type=template&id=666e1033"
import script from "./ExBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ExBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./ExBreadcrumbs.vue?vue&type=style&index=0&id=666e1033&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports